module.exports = __webpack_public_path__ + "static/media/guests.d562b6ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/invitation-page/guests.png
// module id = 1551
// module chunks = 22 24